import { annnouncementOptionData } from "../../../../_constants/staticData";
import React, { useEffect, useState } from "react";
import CreateBundle from "../../Teachers/CreateCourse/CreateBundle";
import axiosInstance from "../../../../axios";
import AnnouncementCard from "./AnnouncementCard";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { Loading } from "../../../Other/Loading";
import { useSelector } from "react-redux";
import {
  Bell,
  Calendar,
  BookOpen,
  Trash2,
  Edit3,
  Plus,
  ArrowLeft,
  ArrowRight,
  CheckCircle2,
  ChevronRight,
  AlertCircle,
  Info,
  Check,
  Search,
} from "lucide-react";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export default function Announcement() {
  const { user } = useSelector((state) => state.users);
  const isStudent = user?.role === 2 || user?.role === "2";
  const [current, setcurrent] = useState(0);
  const [payload, setPayload] = useState({
    name: "",
    description: "",
    data: [],
  });
  const [selectAnnounceCourse, setSelectAnnounceCourse] = useState();
  const [success, setSuccess] = useState(false);
  const [load, setload] = useState(false);
  const [announceData, setAnnounceData] = useState([]);
  const [deleteModal, setDeleteModal] = useState({
    modal: false,
    id: null,
    index: null,
  });
  const [selectedIds, setSelectedIds] = useState([]);

  const handleSelectToggle = (id, checked) => {
    if (checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
    }
  };

  const handleSelectAllToggle = (checked) => {
    if (checked) {
      setSelectedIds(announceData.map((a) => a.id));
    } else {
      setSelectedIds([]);
    }
  };

  const performDeleteBulk = async (toDeleteGlobally, toDeleteLocally) => {
    if (toDeleteGlobally.length > 0) {
      await Promise.all(
        toDeleteGlobally.map(async (id) => {
          try {
            await axiosInstance.delete(`${REACT_APP_LOGIN_API_BASEURL}/announcement/${id}`);
          } catch (err) {
            console.error(`Error globally deleting announcement ${id}:`, err);
            toDeleteLocally.push(id);
          }
        })
      );
    }

    if (toDeleteLocally.length > 0) {
      const deletedIds = JSON.parse(localStorage.getItem("deleted_announcements") || "[]");
      const updated = [...new Set([...deletedIds, ...toDeleteLocally])];
      localStorage.setItem("deleted_announcements", JSON.stringify(updated));
    }

    setSelectedIds([]);
    fetch();
    window.dispatchEvent(new Event("update_announcements_count"));
  };

  const handleDeleteSelected = () => {
    if (window.confirm(`Are you sure you want to delete the ${selectedIds.length} selected announcement(s)?`)) {
      const toDeleteGlobally = [];
      const toDeleteLocally = [];

      selectedIds.forEach((id) => {
        const item = announceData.find((a) => a.id === id);
        if (item) {
          const isAuthorOrAdmin =
            user?.role === 1 ||
            user?.role === "1" ||
            item.createdBy === user?.id ||
            item.createdBy === user?.id?.toString();
          if (isAuthorOrAdmin && !isStudent) {
            toDeleteGlobally.push(id);
          } else {
            toDeleteLocally.push(id);
          }
        }
      });

      performDeleteBulk(toDeleteGlobally, toDeleteLocally);
    }
  };

  const handleDeleteAll = () => {
    if (window.confirm("Are you sure you want to delete all announcements?")) {
      const allIds = announceData.map((a) => a.id);

      const toDeleteGlobally = [];
      const toDeleteLocally = [];

      allIds.forEach((id) => {
        const item = announceData.find((a) => a.id === id);
        if (item) {
          const isAuthorOrAdmin =
            user?.role === 1 ||
            user?.role === "1" ||
            item.createdBy === user?.id ||
            item.createdBy === user?.id?.toString();
          if (isAuthorOrAdmin && !isStudent) {
            toDeleteGlobally.push(id);
          } else {
            toDeleteLocally.push(id);
          }
        }
      });

      performDeleteBulk(toDeleteGlobally, toDeleteLocally);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const date = new Date();
    const getExpirationDate = date.setDate(date.getDate() + 10);
    setPayload((prev) => {
      return {
        ...prev,
        data:
          selectAnnounceCourse && selectAnnounceCourse.length > 0
            ? selectAnnounceCourse.map((ele) => ({
                courseId: ele.courseId || ele.ID || ele.Id,
                activationDate: new Date(),
                expirationDate: new Date(getExpirationDate),
              }))
            : [],
        description: value,
        name: "yslearn annoucement testing two",
      };
    });
  };

  const handleClick = async () => {
    try {
      const res = await axiosInstance.post(`${REACT_APP_LOGIN_API_BASEURL}/announcement`, payload);

      if (!res.data?.error) {
        setSuccess(true);
        setcurrent(0);
      }
    } catch (error) {
      console.error("Error while creating announcement:", error);
    }
  };

  const fetch = async () => {
    try {
      setload(true);
      const url = isStudent
        ? `${REACT_APP_LOGIN_API_BASEURL}/course-annnouncement`
        : `${REACT_APP_LOGIN_API_BASEURL}/announcement`;
      const res = await axiosInstance.get(url);

      if (!res.data?.error) {
        const rawAnnouncements = isStudent ? res.data.message : res.data.data;
        const deletedIds = JSON.parse(localStorage.getItem("deleted_announcements") || "[]");
        const filtered = (rawAnnouncements || []).filter((ann) => !deletedIds.includes(ann.id));
        setAnnounceData(filtered);
      }
    } catch (error) {
      console.error("Error fetching announcements:", error);
    } finally {
      setload(false);
    }
  };

  useEffect(() => {
    if (current === 0) {
      fetch();
    }
  }, [current]);

  useEffect(() => {
    if (announceData) {
      if (announceData.length > 0) {
        const currentSeen = JSON.parse(localStorage.getItem("seen_announcements") || "[]");
        const newSeen = [...new Set([...currentSeen, ...announceData.map((a) => a.id)])];
        localStorage.setItem("seen_announcements", JSON.stringify(newSeen));
      }
      window.dispatchEvent(new Event("update_announcements_count"));
    }
  }, [announceData]);

  const accouncementActionHandler = (status, element) => {
    if (status === "create") {
      setcurrent(1);
      setSelectAnnounceCourse();
      setPayload({
        name: "",
        description: "",
        data: [],
      });
    } else if (element?.id || element?.Id) {
      setSelectAnnounceCourse(element.courses || []);
      setPayload({
        ...payload,
        description: status,
        update: true,
        updateId: element?.id || element?.Id,
      });
      setcurrent(2); // Directly go to step 2 (edit description & save) when updating
    }
  };

  const updateHandlerAnnouncement = async () => {
    try {
      const date = new Date();
      const getExpirationDate = date.setDate(date.getDate() + 10);

      const response = await axiosInstance.put(
        `${REACT_APP_LOGIN_API_BASEURL}/announcement/${payload?.updateId}`,
        {
          name: "demo",
          description: payload.description,
          data:
            selectAnnounceCourse && selectAnnounceCourse.length > 0
              ? selectAnnounceCourse.map((item) => ({
                  courseId: item.courseId || item.ID || item.Id,
                  activationDate: new Date(),
                  expirationDate: new Date(getExpirationDate),
                }))
              : [],
        }
      );

      if (!response.data.error) {
        setSuccess(true);
        setcurrent(0);
        setPayload({
          courses: [],
          description: "",
        });
        setSelectAnnounceCourse();
      }
    } catch (error) {
      console.error("Error updating announcement:", error);
    }
  };

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-[#eef2f7] pb-10 px-4 md:px-6 pt-5">
      {/* Visual Header Banner */}
      <div className="bg-gradient-to-br from-[#1e3a6e] via-[#264b82] to-indigo-700 rounded-3xl p-6 md:p-8 text-white relative overflow-hidden shadow-xl shadow-blue-900/10 mb-8 max-w-7xl mx-auto">
        <div className="absolute inset-0 opacity-5 pointer-events-none select-none">
          <Bell className="absolute right-12 top-12 w-48 h-48" />
        </div>
        <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <span className="bg-white/10 text-white border border-white/20 text-xs font-black uppercase tracking-widest px-3.5 py-1 rounded-full">
              Student Board
            </span>
            <h1 className="text-3xl md:text-4xl font-black mt-3 tracking-tight leading-none">Announcements Hub</h1>
            <p className="text-blue-100 text-sm md:text-base font-semibold mt-2.5 max-w-xl leading-relaxed">
              Stay updated with the latest assignments, schedule updates, and notes published by your course instructors.
            </p>
          </div>
          {current === 0 && !isStudent && (
            <button
              onClick={() => accouncementActionHandler("create")}
              className="flex items-center justify-center gap-2 bg-white text-[#264b82] hover:bg-blue-50 px-6 py-3.5 rounded-2xl font-black text-sm uppercase tracking-wider transition-all shadow-lg shadow-blue-950/10 active:scale-95 flex-shrink-0"
            >
              <Plus size={16} strokeWidth={3} /> Create Announcement
            </button>
          )}
        </div>
      </div>

      {/* Main Container */}
      <div className="max-w-7xl mx-auto">
        {current === 0 && (
          <section className="animate-in fade-in duration-500">
            {load ? (
              <div className="bg-white rounded-3xl border border-slate-200 p-12 flex justify-center items-center shadow-sm">
                <Loading />
              </div>
            ) : (
              <>
                {/* Bulk actions and info header */}
                {announceData && announceData.length > 0 && (
                  <div className="bg-white rounded-2xl border border-slate-200 p-4 mb-6 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <label className="flex items-center gap-3 cursor-pointer group">
                      <div className="relative">
                        <input
                          type="checkbox"
                          className="peer sr-only"
                          checked={selectedIds.length === announceData.length && announceData.length > 0}
                          onChange={(e) => handleSelectAllToggle(e.target.checked)}
                        />
                        <div className="w-5.5 h-5.5 border-2 border-slate-200 rounded-lg bg-white peer-checked:bg-[#264b82] peer-checked:border-[#264b82] transition-all flex items-center justify-center shadow-sm">
                          {selectedIds.length === announceData.length && announceData.length > 0 && (
                            <Check size={11} className="text-white" strokeWidth={4} />
                          )}
                        </div>
                      </div>
                      <span className="text-sm font-extrabold text-slate-600 group-hover:text-slate-800 transition-colors">
                        Select All Announcements
                      </span>
                    </label>

                    <div className="flex items-center gap-2.5">
                      {selectedIds.length > 0 && (
                        <button
                          onClick={handleDeleteSelected}
                          className="flex items-center gap-1.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-100/70 px-4.5 py-2.5 rounded-xl font-bold text-xs uppercase tracking-wider transition-all active:scale-95 shadow-sm"
                        >
                          <Trash2 size={13} /> Delete Selected ({selectedIds.length})
                        </button>
                      )}
                      <button
                        onClick={handleDeleteAll}
                        className="flex items-center gap-1.5 bg-slate-50 text-slate-650 text-slate-600 border border-slate-200 hover:bg-slate-100 px-4.5 py-2.5 rounded-xl font-bold text-xs uppercase tracking-wider transition-all active:scale-95 shadow-sm"
                      >
                        <Trash2 size={13} /> Delete All
                      </button>
                    </div>
                  </div>
                )}

                {/* Empty State */}
                {announceData?.length === 0 && (
                  <div className="flex flex-col items-center justify-center py-16 bg-white rounded-[2rem] border border-slate-200 p-8 text-center max-w-2xl mx-auto shadow-sm">
                    <div className="bg-slate-50 w-20 h-20 rounded-3xl flex items-center justify-center mb-6 shadow-sm border border-slate-100 text-slate-400">
                      <Bell size={36} />
                    </div>
                    <h3 className="text-xl font-black text-slate-800 tracking-tight mb-2">No Announcements Yet</h3>
                    <p className="text-slate-550 text-slate-500 text-sm font-semibold max-w-sm mx-auto leading-relaxed">
                      You're all caught up! When instructors publish announcements or reminders, they will appear here.
                    </p>
                  </div>
                )}

                {/* Announcement Cards List */}
                <div className="space-y-4">
                  {announceData?.map((ele) => (
                    <AnnouncementCard
                      key={ele.id}
                      element={ele}
                      deleteModal={deleteModal}
                      setDeleteModal={setDeleteModal}
                      accouncementActionHandler={accouncementActionHandler}
                      fetchAnnouncements={fetch}
                      isStudent={isStudent}
                      user={user}
                      isSelected={selectedIds.includes(ele.id)}
                      onSelectToggle={(checked) => handleSelectToggle(ele.id, checked)}
                    />
                  ))}
                </div>
              </>
            )}
          </section>
        )}

        {/* Step 1: Select Target Courses */}
        {current === 1 && (
          <div className="max-w-4xl mx-auto bg-white rounded-3xl border border-slate-200 p-6 md:p-8 shadow-sm animate-in fade-in duration-500">
            {/* Stepper */}
            <div className="flex items-center justify-center mb-8 gap-4 select-none">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-[#264b82] text-white flex items-center justify-center font-black text-sm shadow-md shadow-blue-900/10">1</div>
                <span className="text-sm font-black text-slate-800">Select Target Courses</span>
              </div>
              <div className="w-12 h-0.5 bg-slate-250 bg-slate-200" />
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-slate-100 text-slate-400 flex items-center justify-center font-bold text-sm">2</div>
                <span className="text-sm font-bold text-slate-400">Write Details</span>
              </div>
            </div>

            <CreateBundle
              announcement={true}
              setSelectAnnounceCourse={setSelectAnnounceCourse}
              selectAnnounceCourse={selectAnnounceCourse}
              setAnnounceData={setAnnounceData}
            />

            <div className="flex items-center justify-between mt-8 pt-6 border-t border-slate-100">
              <button
                className="flex items-center gap-1.5 px-5 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-slate-600 rounded-xl font-bold text-xs uppercase tracking-wider transition-all active:scale-95"
                onClick={() => setcurrent(0)}
              >
                <ArrowLeft size={14} /> Back
              </button>
              {(payload?.update || (selectAnnounceCourse && selectAnnounceCourse?.length > 0)) && (
                <button
                  className="flex items-center gap-1.5 bg-[#264b82] text-white hover:bg-[#1e3a6e] px-6 py-2.5 rounded-xl font-black text-xs uppercase tracking-wider transition-all active:scale-95 shadow-md shadow-blue-900/15"
                  onClick={() => setcurrent(2)}
                >
                  Next <ArrowRight size={14} />
                </button>
              )}
            </div>
          </div>
        )}

        {/* Step 2: Write Details */}
        {current === 2 && (
          <div className="max-w-3xl mx-auto bg-white rounded-3xl border border-slate-200 p-6 md:p-8 shadow-sm animate-in fade-in duration-500">
            {/* Stepper */}
            <div className="flex items-center justify-center mb-8 gap-4 select-none">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-emerald-500 text-white flex items-center justify-center font-black text-sm shadow-md shadow-emerald-500/10">
                  <Check size={14} strokeWidth={3} />
                </div>
                <span className="text-sm font-bold text-slate-500">Select Target Courses</span>
              </div>
              <div className="w-12 h-0.5 bg-emerald-500" />
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-[#264b82] text-white flex items-center justify-center font-black text-sm shadow-md shadow-blue-900/10">2</div>
                <span className="text-sm font-black text-slate-800">Write Details</span>
              </div>
            </div>

            <div className="mb-6">
              <h4 className="text-[10px] font-black text-[#264b82] uppercase tracking-widest mb-3">Selected Courses</h4>
              <div className="grid grid-cols-1 gap-2.5">
                {selectAnnounceCourse &&
                  selectAnnounceCourse?.length > 0 &&
                  selectAnnounceCourse.map((ele, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-3.5 bg-slate-50 border border-slate-100 rounded-2xl"
                    >
                      <div>
                        <h4 className="font-extrabold text-slate-800 text-sm leading-snug">{ele.CourseName || ele.courseName}</h4>
                        <div className="flex flex-wrap items-center gap-2 text-xs font-semibold text-slate-405 text-slate-400 mt-1">
                          {ele?.Category && <span>{ele?.Category}</span>}
                          {ele?.Category && <span className="w-1.5 h-1.5 rounded-full bg-slate-300" />}
                          <span>
                            <strong>Duration: </strong>
                            {ele?.Duration ? ` ${ele.Duration} hrs` : "N/A"}
                          </span>
                          <span className="w-1.5 h-1.5 rounded-full bg-slate-300" />
                          <span>
                            <strong>Language: </strong>
                            {ele.Language || "English"}
                          </span>
                        </div>
                      </div>
                      <div className="w-6 h-6 rounded-lg bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-600">
                        <CheckCircle2 size={13} />
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <label className="text-[10px] font-black text-[#264b82] uppercase tracking-widest block mb-2">Announcement Template (Optional)</label>
                <select
                  onChange={(e) => handleChange(e)}
                  value={payload.description}
                  className="w-full p-3.5 rounded-xl border border-slate-200 hover:border-slate-300 bg-white font-extrabold text-slate-655 text-slate-500 text-sm outline-none transition-all cursor-pointer"
                >
                  <option value="">
                    Select a template announcement (optional)...
                  </option>
                  {annnouncementOptionData.map((option, idx) => (
                    <option key={idx} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="text-[10px] font-black text-[#264b82] uppercase tracking-widest block mb-2">Announcement Content</label>
                <textarea
                  placeholder="Write your announcement description here..."
                  value={payload.description}
                  onChange={(e) => handleChange(e)}
                  rows="6"
                  className="w-full p-4 rounded-2xl border border-slate-200 hover:border-slate-300 bg-white text-slate-800 text-sm leading-relaxed outline-none transition-all resize-none min-h-[140px]"
                  required
                />
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                <button
                  className="flex items-center gap-1.5 px-5 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-slate-655 text-slate-500 rounded-xl font-bold text-xs uppercase tracking-wider transition-all active:scale-95"
                  onClick={() => setcurrent(current - 1)}
                >
                  <ArrowLeft size={14} /> Back
                </button>
                <button
                  className="flex items-center gap-1.5 bg-[#264b82] text-white hover:bg-[#1e3a6e] px-6 py-2.5 rounded-xl font-black text-xs uppercase tracking-wider transition-all active:scale-95 shadow-md shadow-blue-900/15"
                  onClick={payload?.update ? updateHandlerAnnouncement : handleClick}
                >
                  <CheckCircle2 size={13} />
                  {payload?.update ? "Update Announcement" : "Publish Announcement"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Success Alert Modal */}
      {success && (
        <OverlayContainer>
          <div className="max-w-md w-full mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl p-8 text-center animate-in zoom-in-95 duration-300">
            <div className="w-16 h-16 bg-emerald-50 border border-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-emerald-600">
              <CheckCircle2 className="w-8 h-8" strokeWidth={2.5} />
            </div>
            <h3 className="text-xl font-black text-slate-800 mb-1 tracking-tight">Announcement Published!</h3>
            <p className="text-slate-500 text-sm font-semibold mb-6 leading-relaxed">
              Your announcement has been successfully broadcast to all enrolled students.
            </p>
            <button
              className="w-full py-3.5 bg-[#264b82] hover:bg-[#1e3a6e] text-white rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-blue-900/20 transition-all active:scale-95"
              onClick={() => setSuccess(false)}
            >
              Continue
            </button>
          </div>
        </OverlayContainer>
      )}
    </div>
  );
}
